// TypeScript entry point
import * as Turbo from "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"

// Start Stimulus
const application = Application.start()

// TypeScript example function
function greet(name: string): string {
  return `Hello, ${name}!`;
}

document.addEventListener("turbo:load", () => {
  console.log(greet("Rails with TypeScript"));
});

export { application }
